import type { Case } from '../../types';
import CaseAssistantTab from '../../components/tabs/CaseAssistantTab';

interface Props {
  caseData: Case;
}

export default function AssistantSection({ caseData }: Props) {
  return (
    <div className="flex-1 overflow-y-auto p-6 min-h-0">
      <CaseAssistantTab caseId={caseData.public_id} />
    </div>
  );
}
